

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_lxc190zq4j = () => {
                    
                        if (document.querySelector('.beae-x69y8bu3:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-x69y8bu3:not([data-beae-bind])'),
                                
                                id: 'beae-x69y8bu3',
                                isLive: true
                            });
                            document.querySelector('.beae-x69y8bu3:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-dwwqwwaf:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-dwwqwwaf:not([data-beae-bind])'),
                                
                                id: 'beae-dwwqwwaf',
                                isLive: true
                            });
                            document.querySelector('.beae-dwwqwwaf:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-1w0ii2jf:not([data-beae-bind])')) {
                            (function() {let e=this.$el.querySelector(".beae-shopify__newsletter-form-wrapper");if(e&&typeof getCurrentScreen<"u"&&this.isLive){let n=function(){let o=getCurrentScreen(t),r=a[o.name],l=r?r.design:null;l&&e.setAttribute("data-layout",s(l,o,"design"))},s=function(o,r,l){if(o)return o;let c=t.findIndex(m=>m.name==r.name),d=(m,_)=>{let u=t[m].name,g="";return a[u][_]?g=a[u][_]:m>0&&(g=d(m-1,_)),g};return d(c,l)},t=JSON.parse(e.getAttribute("data-screens")),a=JSON.parse(e.getAttribute("data-responsive"));window.addEventListener("resize",n),n()}}).call({
                                $el: document.querySelector('.beae-1w0ii2jf:not([data-beae-bind])'),
                                
                                id: 'beae-1w0ii2jf',
                                isLive: true
                            });
                            document.querySelector('.beae-1w0ii2jf:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_lxc190zq4j()
                } else {
                    window.beaePageJS.push(jsHandle_lxc190zq4j)
                }
            